<template>
  <div>
    <v-card class="pa-3">
        <v-card-text>
          <v-row>
            Вы уверены что добавляемого пользователя нет в системе или он не может самостоятельно завести ЛК? Убедительная просьба не "плодить" лишние аккаунты.
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="4">
              <v-text-field
                v-model="lastName"
                :label="surNameLabel"
                placeholder="Фамилия"
                :error-messages="lastNameValidate"
                :error="lastName_error"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4">
              <v-text-field
                v-model="name"
                 placeholder="Имя"
                :label="nameLabel"
                required
                :error-messages="nameValidate"
                :error="name_error"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4">
              <v-text-field
                v-model="middleName"
                 placeholder="Отчество"
                :label="patronymicLabel"
                required
                :error-messages="middleNameValidate"
                :error="middleName_error"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" lg="6">
              <v-autocomplete
                v-model="valueOrganization"
                :items="organizations"
                item-value="id"
                item-text="name"
                :label='scienceOrganizationLabel'
                prepend-icon="mdi-city"
                :error="valueOrganization_error"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="6">
              <v-autocomplete
                v-model="academic_degree"
                :items="rang"
                item-text="title"
                item-value="id"
                :label='scienceDegreeLabel'
                prepend-icon="mdi-account"
                :error="academic_degree_error"
                >
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" lg="3">
              <v-menu
                v-model="birthDay"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedDateFormatted"
                    :label="birthDayLabel"
                    :hint="hint"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date" 
                  no-title
                  scrollable
                  @input="birthDay = false"
                  first-day-of-week="1"
                  locale='ru-RU'
                  min="1950-01-01"
                  ></v-date-picker>
              </v-menu>

            </v-col>
            <v-col cols="12" lg="5">
              <form autocomplete="off">
              
                <v-text-field
                  v-model="email"
                  label="E-mail"
                  placeholder="synchrotron@nrcki.ru"
                  autocomplete="new-password"
                  required
                  :error-messages="emailValidate"
                  :error="email_error"
                ></v-text-field>
              </form>
            </v-col>
            <v-col cols="12" lg="4">
              <form autocomplete="off">
                <v-text-field
                  class="phone-number"
                  v-model="phone"
                  placeholder="918 333 33 33"
                  required
                  :error-messages="phoneValidate"
                  :error="phone_error"
                ></v-text-field>
              </form>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              :color="buttonColor"
              :loading="loaded"
              dark
              outlined
              class="mr-4"
              style="margin-top:10px;"
              @click="submit">{{buttonTextSubmit}}
            </v-btn>
            <v-btn
              color="red darken-1"
              :loading="loaded"
              dark
              outlined
              class="mr-4"
              style="margin-top:10px;"
              @click="$emit('closeModal')">Отмена
            </v-btn>
        </v-card-actions>
      </v-card>


      <v-row justify="center">
        <v-dialog
          v-model="dialog"
          max-width="600">
          <v-card>
            <v-card-title class="headline">{{ $t('error') }}</v-card-title>
            <v-card-text>
              {{info}}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                text
                @click="dialog = false, info = ''">
                {{$t('ok')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

  </div>
</template>

<script>
import intlTelInput from 'intl-tel-input';
import { validationMixin } from 'vuelidate';
import { required, maxLength, email, minLength } from 'vuelidate/lib/validators/';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'NewUser',
  mixins: [validationMixin],
  validations: {
    name: { required, maxLength: maxLength(10) },
    email: { required, email },
    select: { required },
  },

  components: {
  },

  data: () => ({
    loaded: false,
    name_error: false,
    lastName_error: false,
    middleName_error: false,
    phone_error: false,
    email_error: false,
    valueOrganization_error: false,
    academic_degree_error: false,
    dialog: false,
    name: '',
    lastName: '',
    middleName: '',
    phone: '',
    email: '',
    info: '',
    select: null,
    academic_degree: '',
    valueOrganization: '',
    organizations: [],
    rang: [],
    date: new Date().toISOString().substr(0, 10),
    birthDay: false,
    buttonColor: '#16336e',
    rules: {
      required: (value) => !!value || 'Required.',
      min: (v) => v.length >= 8 || 'Min 8 characters',
    },
    disabled: true,
    codeCountry: ''
  }),

  mounted() {
    let phoneInput = document.querySelector('.phone-number input');
    this.codeCountry = intlTelInput(phoneInput, {
      separateDialCode: true,
      preferredCountries: ['ru', 'ua', 'kz', 'by']
    })
  },

  async beforeMount() {
      const rang = await this.GET_ACADEMIC_DEGREE_REG(this.GETTERS_APP_LANGUAGE_NTRANSLATE);
      const organizations = await this.ORGANIZATION(this.GETTERS_APP_LANGUAGE_NTRANSLATE);

      this.organizations = await organizations.data;
      this.rang = await rang.data;
  },

  validations: {
    lastName: {
      required,
      minLength: minLength(1)
    },
    name: {
      required,
      minLength: minLength(1)
    },
    middleName: {
      required,
      minLength: minLength(2)
    },
    phone: {
      required,
      validFormat: val => /\d{1,}/.test(val)
    },
    academic_degree: {
      required,
      minLength: minLength(1)
    },
    email: {
      required,
      email
    },
  },
  computed: {
    ...mapGetters([
      'GETTERS_APP_LANGUAGE_NTRANSLATE',
      'GETTERS_APP_LANGUAGE'
    ]),
    lastNameValidate() {
      return this.$v.lastName.$invalid && this.$v.lastName.required ?
      this.$t('Registration.three_or_more_characters') : null
    },
    nameValidate() {
      return this.$v.name.$invalid && this.$v.name.required ?
      this.$t('Registration.three_or_more_characters') : null
    },
    middleNameValidate() {
      return this.$v.middleName.$invalid && this.$v.middleName.required ?
      this.$t('Registration.three_or_more_characters') : null
    },
    emailValidate() {
      return this.$v.email.$invalid && this.$v.email.required ?
      this.$t('Registration.enter_valid_email') : null
    },
    phoneValidate() {
      return this.$v.phone.$invalid && this.$v.phone.required ?
      this.$t('Registration.correct_phone_number') : null
    },
    academic_degree_validate() {
      return this.$v.academic_degree.$invalid && this.$v.academic_degree.required ?
      this.$t('Registration.select_value') : null
    },
    surNameLabel(){
      return this.$t('sur-name-label')
    },
    scienceOrganizationLabel(){
      return this.$t('organization-label')
    },
    nameLabel(){
      return this.$t('name-label')
    },
    patronymicLabel(){
     return this.$t('patronymic-label')
    },
    hint(){
      return this.$t('hint-bd')
    },
    birthDayLabel(){
      return this.$t('bd-label')
    },
    phoneLabel(){
      return this.$t('phone-label')
    },
    scienceDegreeLabel(){
      return this.$t('degree-label')
    },
    buttonTextSubmit(){
      return this.$t('create-account')
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    selectErrors() {
      const errors = [];
      if (!this.$v.select.$dirty) return errors;
      if (!this.$v.select.required) errors.push('Item is required');
      return errors;
    },
    count() {
      return this.$store.state.count;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      if (!this.$v.name.maxLength) errors.push('очень длинное имя');
      if (!this.$v.name.required) errors.push('укажите Ваше имя');
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email) errors.push('неверный e-mail');
      if (!this.$v.email.required) errors.push('введите e-mail');
      return errors;
    },
  },
  methods: {
    ...mapActions([
      'REGISTRATION',
      'GET_ACADEMIC_DEGREE_REG',
      'ORGANIZATION',
      'CREATE_NEW_PROFILE',
    ]),

    get_params() {
      return {
        username: this.email,
        email: this.email,
        first_name: this.name,
        last_name: this.lastName,
        password: '1111',
        password_confirm: '1111',
        individual: {
          middle_name: this.middleName,
          phone_number: this.codeCountry.getSelectedCountryData().dialCode + this.phone,
          academic_degree: this.academic_degree,
          organization: this.valueOrganization,
          birth_date: this.date,
        },
      };
    },

    async submit() {
      this.loaded = true;
      const userData = this.get_params();

      this.academic_degree.length === 0 ? this.academic_degree_error = true : this.academic_degree_error = false
      this.valueOrganization.length === 0 ? this.valueOrganization_error = true : this.valueOrganization_error = false

      this.name.length === 0 ? this.name_error = true : this.name_error = false
      this.lastName.length === 0 ? this.lastName_error = true : this.lastName_error = false
      this.middleName.length === 0 ? this.middleName_error = true : this.middleName_error = false
      this.phone.length === 0 ? this.phone_error = true : this.phone_error = false
      this.email.length === 0 ? this.email_error = true : this.email_error = false
      
  
      if ((this.academic_degree.length === 0) ||
        (this.valueOrganization.length === 0) ||
        this.$v.$invalid) {
          this.buttonColor = '#DC5959'
          this.loaded = false
          return
        };
      
      this.buttonColor = '#656565';

      this.CREATE_NEW_PROFILE(userData)
      .then((res) => {
        if(res.errors !== undefined){
          this.show_reg_errors(res.errors)
        }
        else{
          this.$emit('closeModal')
          this.$emit('createUser', res.profile_id)
          this.loaded = false
        }

      })
      .catch( (error) => {
        console.log('CREATE_NEW_PROFILE_error', error)
        this.$messageHelper(`что-то пошло не так... попробуйте перезагрузить страницу`, 'error', 5000)
        this.loaded = false
      })

    },
    
    show_reg_errors(errors){
      Object.entries(errors).forEach(([key, val]) => {
        val.forEach(t => {
          this.info += t;
          this.info += ' ';
        })  
      });

      this.loaded = false
      this.dialog = true;
      this.buttonColor = this.$mainColor;
    },

    clear() {
      this.$v.$reset();
      this.name = '';
      this.email = '';
      this.select = null;
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
  },
  watch: {
    email(val){
      this.email = val.toLowerCase()
    },

    async GETTERS_APP_LANGUAGE_NTRANSLATE(val) {
      try {
        const rang = await this.GET_ACADEMIC_DEGREE(val);
        const organizations = await this.ORGANIZATION(val);
        
        this.organizations = organizations.data;
        this.rang = rang.data;
    } catch (ex) {
      console.log('ex ---> ', ex);
      // this.$toasted.show('Произошла ошибка!', { type: 'error', duration: 3000 });
    }
    }
  }
};
</script>
<style lang="scss">
.invalid {
  color: red;
  border: 1px solid red !important;
}
</style>